import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const CarouselControls = ({ items, activeIndex, onSelect, onPrev, onNext }) => (
  <div className="mt-10 flex items-center gap-6">
    <div className="flex gap-2">
      {items.map((p, i) => {
        const isActive = i === activeIndex;
        return (
          <button
            key={p.id}
            data-testid={`showcase-dot-${i}`}
            onClick={() => onSelect(i)}
            className={`h-[2px] transition-all duration-500 ${
              isActive ? "w-10 bg-gold" : "w-5 bg-white/15"
            }`}
            aria-label={`Project ${i + 1}`}
          />
        );
      })}
    </div>
    <div className="flex gap-2 ml-auto">
      <button
        data-testid="showcase-prev"
        onClick={onPrev}
        className="w-10 h-10 rounded-full border border-white/10 hover:border-gold/60 text-themed-muted hover:text-gold transition-colors flex items-center justify-center"
        aria-label="Previous"
      >
        <ChevronLeft size={16} />
      </button>
      <button
        data-testid="showcase-next"
        onClick={onNext}
        className="w-10 h-10 rounded-full border border-white/10 hover:border-gold/60 text-themed-muted hover:text-gold transition-colors flex items-center justify-center"
        aria-label="Next"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  </div>
);

export default CarouselControls;
